import './neutrals.css';
export default {
    "white": "#fff",
    "neutral-100": "#f8f7fa",
    "neutral-200": "#efedf2",
    "neutral-300": "#dddae3",
    "neutral-400": "#c1bdc7",
    "neutral-500": "#918d99",
    "neutral-600": "#716b7a",
    "neutral-700": "#585163",
    "neutral-800": "#3a3247",
    "neutral-900": "#261b36",
    "neutral-1000": "#13002d"
};
